<template lang="pug">
  include /mixins
  +b.ds-panel--space_lg.--space_sm-xl
    +e.element--offset_horizontal
      template(v-for='parent in filter.attribute.values')
        template(v-if='!parent.props.depth')
          ui-accordion(
            :init='!!findCheckedChild(parent.props)'
            :options='parent'
            :is-calculate-height='false'
          )
            template(#default='{ activeState, toggleActive, collapse }')
              +b.tt-accordion.tt-space_mt--4(
              )
                +e.question.--indent_none.--spaced_bottom-none.--clear-all
                  +e.text(style='width: calc(100% - 32px)')
                    +b.tt-link.--appearance_hovered.--black.variant_start.ds-caption--size_sm.--regular.A(
                      :href='parent.props.url'
                      @click.prevent='!(isAvailable(parent.id, parent.label)) ? false : goTo(parent.props.url)'
                      :class='{"is-blocked": !(isAvailable(parent.id, parent.label))}'
                    ) {{ parent.props.title }}
                  +e.icon.mdi.I(
                    v-if='checkIsParent(parent.id)'
                    :class='[{"is-blocked": !(isAvailable(parent.id, parent.label))}, activeState ? "mdi-minus" : "mdi-plus" ]'
                    @click='toggleActive()',
                  )
                +e.description(
                  v-if="activeState"
                )
                  template(v-for='child in filter.attribute.values')
                    ui-accordion(
                      :init='!!findCheckedChild(child.props)'
                      v-if='parent.id === child.props.parent'
                      :is-calculate-height='false'
                    )
                      template(#default='{ activeState, toggleActive, collapse }')
                        +b.tt-accordion.tt-space_mt--3(
                        )
                          +e.question.--indent_none.--spaced_bottom-none.--clear-all
                            +e.text
                              +b.d-control-input.--appearance_flexible(
                                :style='{"margin-left": `${getSpace(child.props.depth)}px`}'
                              )
                                +e.element.INPUT(
                                  type='checkbox'
                                  :value='child.props.label',
                                  :name='filter.attribute.label'
                                  v-model='checked'
                                  :input-label='child.props.title',
                                  :id='`${filter.attribute.label}:${child.id}`'
                                  @change='clearParent(parent);clearChildren(child.id);submit()'
                                  :disabled='!isAvailable(child.id, child.props.label)'
                                )
                                +e.LABEL.label--for-checkbox(
                                  :class='{"d-control-input__label--spaced": checkIsParent(child.id)}'
                                  :for='`${filter.attribute.label}:${child.id}`'
                                )
                                  //- span(style='color: red') {{ !isAvailable(child.id, child.props.label) }} {{ child.id }} / {{child.props.label}}
                                  tag.fake-link(
                                    :key='`tag_${child.props.label}`'
                                    :tag='url(child.props.label, child.props.id) ? "a" : "span"'
                                    :href='url(child.props.label, child.props.id)'
                                  ) {{ child.props.title }}
                                  //-  #[b(style='font-size: 10px') {{ url(child.props.label, child.id) }}]
                                // for available filters debug

                            +e.icon.mdi.I(
                              v-if='checkIsParent(child.id)'
                              :class='activeState ? "mdi-minus" : "mdi-plus"'
                              @click='toggleActive()',
                            )
                          +e.description(
                            v-if="activeState"
                          )
                            template(v-for='lastChild in filter.attribute.values')
                              ui-accordion(
                                :init='!!findChecked(lastChild.props)'
                                v-if='child.id === lastChild.props.parent'
                                :is-calculate-height='false'
                              )
                                template(#default='{ activeState, toggleActive, collapse }')
                                  +b.tt-accordion.tt-space_mt--3
                                    +e.question.--indent_none.--spaced_bottom-none.--clear-all
                                      +e.text
                                        +b.d-control-input.--variant_child.--appearance_flexible(
                                          :style='{"margin-left": `${getSpace(lastChild.props.depth)}px`}'
                                        )
                                          +e.element.INPUT(
                                            type='checkbox'
                                            :value='lastChild.props.label',
                                            :name='filter.attribute.label'
                                            v-model='checked'
                                            :input-label='lastChild.props.title',
                                            :id='`${filter.attribute.label}:${lastChild.id}`'
                                            @change='clearParent(parent);clearParent(child);submit()'
                                            :disabled='!isAvailable(lastChild.id, lastChild.label)'
                                          )
                                          +e.LABEL.label--for-checkbox.--spaced(
                                            :for='`${filter.attribute.label}:${lastChild.id}`'
                                          )
                                            //- span(style='color: red') {{ !isAvailable(lastChild.id, lastChild.label) }} {{ lastChild.id }}
                                            tag.fake-link(
                                              :key='`tag_${lastChild.props.label}`'
                                              :tag='url(lastChild.props.label, lastChild.props.id) ? "a" : "span"'
                                              :href='url(lastChild.props.label, lastChild.props.id)'
                                            ) {{ lastChild.props.title }}
                                            //-  #[b {{ url(lastChild.props.label, lastChild.id) }}]
                                          // for available filters debug
                                      +e.icon.mdi.I(
                                        v-if='checkIsParent(lastChild.id)'
                                        :class='activeState ? "mdi-minus" : "mdi-plus"'
                                        @click='toggleActive()',
                                      )
                                    +e.description(
                                      v-if="activeState"
                                    )
                                      template(v-for='lastLastChild in filter.attribute.values')
                                        +b.tt-space_mt--3(
                                          v-if='lastChild.id === lastLastChild.props.parent'
                                        )
                                          +e.question.--indent_none.--spaced_bottom-none.--clear-all
                                            +e.text
                                              +b.d-control-input.--variant_child.--appearance_flexible(
                                                :style='{"margin-left": `${getSpace(lastLastChild.props.depth)}px`}'
                                              )
                                                +e.element.INPUT(
                                                  type='checkbox'
                                                  :value='lastLastChild.props.label',
                                                  :name='filter.attribute.label'
                                                  v-model='checked'
                                                  :input-label='lastLastChild.props.title',
                                                  :id='`${filter.attribute.label}:${lastLastChild.id}`'
                                                  @change='clearParent(parent);clearParent(child);clearParent(lastChild);submit()'
                                                  :disabled='!isAvailable(lastLastChild.id, lastLastChild.label)'
                                                )
                                                +e.LABEL.label--for-checkbox.--spaced(
                                                  :for='`${filter.attribute.label}:${lastLastChild.id}`'
                                                )
                                                  //- span(style='color: red') {{ !isAvailable(lastLastChild.id, lastLastChild.label) }} {{ lastLastChild.id }}
                                                  tag.fake-link(
                                                    :key='`tag_${lastLastChild.props.label}`'
                                                    :tag='url(lastLastChild.props.label, lastLastChild.props.id) ? "a" : "span"'
                                                    :href='url(lastLastChild.props.label, lastLastChild.props.id)'
                                                  ) {{ lastLastChild.props.title }}
                                                  //-  #[b {{ url(lastLastChild.props.label, lastLastChild.id) }}]
                                                // for available filters debug
                                            // +e.icon.mdi.I(
                                            //   v-if='checkIsParent(lastChild.id)'
                                            //   :class='activeState ? "mdi-minus" : "mdi-plus"'
                                            //   @click='toggleActive()',
                                            // )
</template>
<script>

import { outstand } from '@utils/helpers'
import urlGeneratorMixin from './urlGenerator'

const DEPTH_SPACE = {
  1: 0,
  2: 24,
  3: 48,
}

export default {
  name: 'CheckboxRenderer',
  props: ['value', 'filter', 'available', 'customCheck', 'label', 'all', 'baseUrl'],
  mixins: [urlGeneratorMixin],
  data() {
    return {
      checked: [],
    }
  },
  computed: {
    categoriesFilter() {
      return this.customCheck && this.label && !this.value
    },
  },
  watch: {
    value(nval) {
      this.checked = this.normalize(nval)
    },
  },
  mounted() {
    this.checked = this.normalize(this.value)
  },
  methods: {
    outstand,
    goTo(url) {
      window.location.href = url
    },
    submit() {
      if (this.categoriesFilter) this.$emit('category-hack')
      this.$nextTick(() => {
        this.$emit('input', this.checked)
      })
    },
    clearParent(parent) {
      this.checked = this.checked.filter(e => e !== parent.props.label)
    },
    clearChildren(id) {
      const children = this.filter.attribute.values.filter(e => e.props.parent === id).map(e => e.props.label)
      this.checked = this.checked.filter(e => !children.includes(e))
    },
    isAvailable(id, label) {
      const customFilter = this.available.categories
      if (customFilter) {
        return this.hasActive(label) || customFilter.find(el => el == id)
      }
    },
    hasActive(val) {
      return this.checked.includes(val)
    },
    findChecked({ label, id }) {
      const children = this.filter.attribute.values.filter(el => el.props.parent === id).map(e => e.props.label)
      return this.checked.includes(label) || children.find(l => this.checked.includes(l))
    },
    findCheckedChild({ label, id }) {
      const children = this.filter.attribute.values.filter(el => el.props.parent === id)
      const grandchildren = this.filter.attribute.values.filter(el => children.find(c => c.props.id === el.props.parent))
      const grandgrandchildren = this.filter.attribute.values.filter(el => grandchildren.find(c => c.id === el.props.parent))
      return this.checked.includes(label) || children.map(e => e.props.label).find(l => this.checked.includes(l)) || grandchildren.map(e => e.props.label).find(l => this.checked.includes(l)) || grandgrandchildren.map(e => e.props.label).find(l => this.checked.includes(l))
    },
    checkIsParent(id) {
      const children = this.filter.attribute.values.filter(el => id === el.props.parent)
      return children.length
    },
    custom() {
      const [l] = this.label.split('/')
      const checked = this.filter.attribute.values.filter(el => l === el.props.label).map(el => el.props.label)
      return checked
    },
    getSpace(depth) {
      return DEPTH_SPACE[depth]
    },
    normalize(value) {
      if (this.categoriesFilter) {
        return this.custom()
      }
      if (!value) return []
      const checked = this.filter.attribute.values.filter(el => value.find(v => v == el.props.label)).map(el => el.props.label)
      return checked
    },
  },
}
</script>
